var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal hide-cancel-btn",
      attrs: {
        id: "welcome-message-modal",
        "close-on-backdrop": false,
        "ok-title": _vm.$t("common.modal.welcome_msg.start")
      },
      on: {
        ok: function($event) {
          return _vm.setTutorialAsChecked("welcome")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
        _c("h5", {
          staticClass: "typography--title",
          domProps: {
            innerHTML: _vm._s(_vm.$t("common.modal.welcome_msg.title"))
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "typography--body-3 typography--color-secondary mb-4 mt-6"
        },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_1")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary mb-4" },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_2")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c("img", {
            staticClass: "mr-12",
            attrs: { src: "/static/images/icon-check.svg" }
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("common.modal.welcome_msg.body_3")) +
              "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40444568", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40444568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WelcomeMessageModal.vue
// module id = Ok4L
// module chunks = 1